/**
 * Submits the footer's localization form whenever one of its selects changes.
 *
 * Deliberately plain: the footer uses native <select> elements rather than the
 * header's `localization-form-component`, whose element ids would collide with
 * the header instance on the same page.
 */
class FooterLocalization extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const form = event.target.form ?? this.querySelector('form');
    form?.submit();
  };
}

if (!customElements.get('footer-localization')) {
  customElements.define('footer-localization', FooterLocalization);
}
